export default __webpack_public_path__ + "static/char-13-anr-acce54856784d26f00c7078f0102e7c9.gif";